import i18n from "../main";

// 🔸 Set the locale
export function setLocale(localeCode) {
  i18n.global.locale.value = localeCode;
  localStorage.setItem("locale", localeCode);
}

// 🔹 Get the current locale
export function getLocale() {
  return i18n.global.locale.value || localStorage.getItem("locale") || "en-US";
}
